// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ElementType,
  ActorType,
  HighlightType,
} from "./types";


export default __t.row({
  highlightId: __t.u64().primaryKey().name("highlight_id"),
  sessionId: __t.u64().name("session_id"),
  createdByPresenceId: __t.u64().name("created_by_presence_id"),
  get createdByActorType() {
    return ActorType.name("created_by_actor_type");
  },
  get highlightType() {
    return HighlightType.name("highlight_type");
  },
  get elementType() {
    return ElementType.name("element_type");
  },
  elementId: __t.string().name("element_id"),
  color: __t.string(),
  pulse: __t.bool(),
  durationMs: __t.option(__t.u32()).name("duration_ms"),
  message: __t.option(__t.string()),
  priority: __t.u8(),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.option(__t.timestamp()).name("expires_at"),
});
